import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { Button, Col, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';
import { Redirect } from 'react-router-dom';
import awardeestore from '../stores/awardeestore';

@observer
export default class Landing extends Component {
	constructor(props) {
		super(props);

		this.state = {
			redirectToProviderInfo: false,
			redirectToUpload:false,
			toggleModal:false,
			
		};
	}

	submit = () => {	
		this.setState({redirectToProviderInfo: true});
	}
	submitUpload=() =>{
		this.setState({redirectToUpload:true});
	}
	toggle = () => {
		if (this.state.toggleModal) {
		  this.setState({ toggleModal: false });
		} else {
		  this.setState({ toggleModal: true });
		}
	  }

	render() {
		const { redirectToProviderInfo,redirectToUpload ,toggleModal} = this.state;

		if(redirectToProviderInfo) {
			return <Redirect to="/providerinfo" />
		}
		if(redirectToUpload){
			return <Redirect to = "/providerAndAwardee"/>
		}

		return (
			<>
				<div className='border-form'>
					<p className='label-font'>
						This AHAH Awardee Profile is for  FCS Supportive Housing (FCS-SH) enrollees that have been selected for an AHAH Rental Assistance Program
						(AHAH-RAP) voucher through the Department Of Commerce Office of AHAH.
					</p>
					
					<div className='spacer' />

					<div className='cards-container'>
						{/* card1 : complete Awardee Profile */}
						<div className='card'>
                         <h2 className='custom-title'>Complete Awardee Profile</h2>
						 <p><h6>Complete the Awardee Profile to reserve an AHAH-RAP voucher. This
						    will be used to determine the awardee&apos;s housing preferences.</h6></p>
							<strong> What to expect next: </strong>
							<ul>
								<li>A shopping letter will be generated based on the information provided.</li>
								<li> Wellpoint will send the shopping letter to the provider.</li>
								<li>Providers can download the voucher and landlord packet documents from the 
								<a href=" https://www.provider.wellpoint.com/washington-provider/patient-care/foundational-community-supports" target="_blank" > <u>FCS provider site.</u></a></li>
								
							</ul>
							<Button type="button" color={"primary"} className={'btn btn-primary awardeeNextBtn'} onClick={this.submit}>
						Complete Awardee Profile
					</Button>
						  
						</div>
						<div className='card'>
							<h2 className='custom-title'>Upload Voucher & Landlord Documents</h2>
							<p>If you've already completed the Awardee Profile, the next step is to submit required documentation signed by the awardee, future landlord and/or FCS providers.</p>
							<p> Please note: You do not have to upload all documents in one session.</p>
							<p> To upload, select the button below:</p>
							<Button type="button" color={"primary"} className={'btn btn-primary awardeeNextBtn'} onClick={this.submitUpload}>
						Upload Documents
					</Button>
					
              <Button className="btn-link"  style={{ marginTop: '1rem' }} color="primary" onClick={this.toggle}>
                <i className='icon icon-info-circle'/>View list of required documents
              </Button>
            
					<div className="spacer" />
            <Modal isOpen={toggleModal} toggle={this.toggle} size='lg'>
              <ModalHeader toggle={this.toggle}>Voucher & Landlord Documents</ModalHeader>
              <ModalBody>
                <div className="spacer" />
                <Label>
                  The following documents will be needed to reserve an AHAH-RAP voucher. They can be found  on the <br/>
				  <a href=" https://www.provider.wellpoint.com/washington-provider/patient-care/foundational-community-supports" target="_blank" ><u> FCS provider site</u></a>, under the 'AHAH' section.
                </Label>
                <Row className='mt-4'>
                  <Col sm="6">
										<strong>Voucher Packet</strong>
										<ol>
											<li>Provider Conflict of Interest Form</li>
											<li>Intent to Rent Form</li>
											<li>Income Verification Worksheet</li>
											<li>Verification of Short-Term Subsidy</li>
											<li>Rent Allowance Request Form</li>
											<li>Housing Health and Safety Inspection (HHSI) Form</li>
											<li>Lead-Based Paint Disclosure</li>
											<li>Change Request Form (as needed)</li>
											<li>Habitability Complaint Process</li>
										</ol>
                  </Col>
                  <Col sm="6">
										<strong>Landlord Packet</strong>
										<ol>
											<li>Property Owner/Agent Verification Form</li>
											<li>Draft Rental Assistance Payment Agreement</li>
											<li>Copy of Blank Lease</li>
											<li>Copy of Executed Lease</li>
											<li>Move-in Walk Through</li>
										</ol>
                  </Col>
                </Row>
								<Button className='btn btn-link btn-file upload-button'  style={{ marginLeft: '650px' }} color='primary' outline onClick={this.toggle}>
								<span>Close</span>
								</Button>
              </ModalBody>
            </Modal>
						</div>
					</div>
				</div>
				<div className='pb-spacer9hRem' />
			</>
		);
	}
}